/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Spec_LicenseInputs */

const en_home_spec_license = /** @type {(inputs: Home_Spec_LicenseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`License`)
};

/**
* | output |
* | --- |
* | "License" |
*
* @param {Home_Spec_LicenseInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const home_spec_license = /** @type {((inputs?: Home_Spec_LicenseInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Spec_LicenseInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_spec_license(inputs)
});
export { home_spec_license as "home.spec.license" }